import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { VFC } from 'react';

import LinkButton from '@/components/CustomButton/LinkButton';
import routes from '@/config/routes';

import styles from './NoItemsAnimon.module.scss';

type Props = {
  message?: string;
};

const NoItemsAnimon: VFC<Props> = ({ message }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.noItemsContainer}>
      <div className={styles.noItemsImageContainer}>
        <img
          src="/images/user-profile-page/mascot.png"
          alt="mascot"
          className={styles.mascotImage}
        />
        <span className={styles.mascotText}>
          {message || t('profilePage.nothing')}
        </span>
      </div>
      <Link href={routes.marketplace} passHref>
        <LinkButton className={styles.browseDiscoverButton}>
          {t('profilePage.browseDiscover')}
        </LinkButton>
      </Link>
    </div>
  );
};

export default NoItemsAnimon;
